import C from 'classnames';
import * as React from 'react';
import { TestingProps } from '../../Types/Testing';

interface ICardTitleProps extends TestingProps {
  className?: string;
  children?: React.ReactNode;
}

export const CardTitle: React.FunctionComponent<ICardTitleProps> = (
  props: ICardTitleProps
) => {
  return (
    <h3
      className={C('card-title mb-0', props.className)}
      data-testid={props.testId}
    >
      {props.children}
    </h3>
  );
};
